<div class="content-style-class" >
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <div fxLayout="column">
      <h2 class="title-style">Trainingscenter</h2>
    </div>
    <div fxLayout="row" fxLayoutGap="5px" class="add-button-style">
      <span  fxLayoutAlign="end" class="buttons-container" >
      </span>
    </div>
  </div>
  <div fxLayout="row" class="content-block">
    <div class="dx-card responsive-paddings card-radius padding-0" >
      <iframe [src]="iframeSrc" width="100%" height="100%" frameborder="0"></iframe>
    </div>
  </div>

</div>
